import React, {memo} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"

export interface DesktopSortContainerProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    children: JSX.Element
}

const DesktopSortContainer = memo(({children, templating}: DesktopSortContainerProps) => {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)

    return <ComponentName>{children}</ComponentName>
})
DesktopSortContainer.displayName = "DesktopSortContainer"
export default connect(DesktopSortContainer)
